import { nextjsPlugin } from '@datadog/browser-rum-nextjs';
import { initializeDatadogLogsAndRUM } from '@newfront-insurance/dd-rum';

initializeDatadogLogsAndRUM('NOVA', {
  rumPlugins: [nextjsPlugin()],
});

export { onRouterTransitionStart } from '@datadog/browser-rum-nextjs';
